// Auto-flips reversible product card images (front/back) on touch and small
// viewports, where the desktop :hover crossfade never fires.
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const FLIP_INTERVAL_MS = 2600;
  const smallViewport = window.matchMedia('(max-width: 989px)');
  let observer = null;

  function getFlipTargets() {
    return Array.from(document.querySelectorAll('.media.media--hover-effect.media--reversible')).filter(
      (media) => media.querySelectorAll('img').length > 1
    );
  }

  function onIntersection(entries) {
    entries.forEach((entry) => {
      const target = entry.target;
      if (entry.isIntersecting) {
        if (!target.dataset.flipIntervalId) {
          const intervalId = window.setInterval(() => {
            target.classList.toggle('card__media--auto-flip');
          }, FLIP_INTERVAL_MS);
          target.dataset.flipIntervalId = String(intervalId);
        }
      } else if (target.dataset.flipIntervalId) {
        window.clearInterval(Number(target.dataset.flipIntervalId));
        delete target.dataset.flipIntervalId;
        target.classList.remove('card__media--auto-flip');
      }
    });
  }

  function start() {
    const targets = getFlipTargets();
    if (targets.length === 0) return;
    observer = new IntersectionObserver(onIntersection, { threshold: 0.5 });
    targets.forEach((target) => observer.observe(target));
  }

  function stop() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    // Keyed on the timer attribute, not the class: a card caught mid-cycle has
    // a running timer but no class, and would otherwise leak.
    document.querySelectorAll('[data-flip-interval-id]').forEach((target) => {
      window.clearInterval(Number(target.dataset.flipIntervalId));
      delete target.dataset.flipIntervalId;
    });
    document
      .querySelectorAll('.card__media--auto-flip')
      .forEach((target) => target.classList.remove('card__media--auto-flip'));
  }

  function handleViewportChange(event) {
    if (event.matches) {
      start();
    } else {
      stop();
    }
  }

  window.addEventListener('DOMContentLoaded', () => {
    if (smallViewport.matches) start();
    smallViewport.addEventListener('change', handleViewportChange);
  });

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      stop();
      if (smallViewport.matches) start();
    });
  }
})();
